module.exports = __webpack_public_path__ + "files/7cd34157d59e515b962f562ff15e3793.png";